var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"uk-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isAllChecked},on:{"change":function($event){return _vm.setAllChecked($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }